/**
 * Centralized raw color values that legitimately live OUTSIDE the design-token
 * system (they are content/branding/visualization data, not theme colors):
 *   - the chitin color-picker preset swatches,
 *   - per-program card / CTA branding (src/config.ts),
 *   - business-flow dashboard node background colors,
 *   - the signature-pad JPEG export background.
 *
 * This is the SINGLE file allowed to hold these literals (see the scss-lint
 * allowlist in tools/scss-lint). Everything else references COLORS so the
 * values stay in one place.
 */
export const COLORS = {
  /** Shared white used for card text labels. */
  white: '#fff',

  /** Preset swatches offered by the chitin color picker. */
  picker: ['#264653', '#2a9d8f', '#e9c46a', '#f4a261', '#e76f51', '#d62828', '#023e8a', '#0077b6', '#0096c7', '#00b4d8', '#48cae4'],

  /** Program-information card branding (src/config.ts). */
  card: {
    purpleBg: '#2D2850',
    blackBg: '#1A1A1A',
    ctaCoral: '#E15067',
    ctaPink: '#FF007F',
  },

  /** Business-flow dashboard node background colors. */
  flow: {
    purple: '#E388FF',
    cyan: '#88EBFF',
    green: '#4BBF73',
    red: '#F86969',
    redSoft: '#F88888',
    redBright: '#F88',
    mint: '#88FFBC',
  },

  /** Opaque background used when exporting a signature as a JPEG. */
  signatureJpegBg: '#FFFFFF',
};
